import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCarga_Mixer = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'adm_mixer',
        name: 'Reparto de Racion',
        component: ViewCarga_Mixer,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
